import * as Icons from '@material-ui/icons';

export const getIconComponent = iconName => {
    return Icons[iconName] || null;
};
